module.exports = __webpack_public_path__ + "img/Stampcard 10 Icon - white.a1d48126.svg";